import { render, staticRenderFns } from "./tecnical_support.vue?vue&type=template&id=74694152"
import script from "./tecnical_support.vue?vue&type=script&lang=js"
export * from "./tecnical_support.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports